import { render, staticRenderFns } from "./kids.vue?vue&type=template&id=000b4e3d&scoped=true&"
import script from "./kids.vue?vue&type=script&lang=js&"
export * from "./kids.vue?vue&type=script&lang=js&"
import style0 from "./kids.vue?vue&type=style&index=0&id=000b4e3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000b4e3d",
  null
  
)

export default component.exports